export default __webpack_public_path__ + "static/media/moneyOut.d7d83c20.svg";